<template>
    <CardPage :section="12" :page="5" :nextDisabled="nextDisabled">
        <p>
            Now let’s review the images and correct descriptions.
        </p>
        <Carousel :length="stepsOrder.length" @change="change">
            <template v-slot:default="slotProps">
                <v-container fluid pa-0>
                    <v-layout row wrap align-center>
                        <v-flex xs12>
                            <ResponsiveImage
                                :src="steps[stepsOrder[slotProps.index]].image"
                                :min-height="150"
                                flex="xs8"
                                :alt="steps[stepsOrder[slotProps.index]].imageText"
                                img-class="elevation-1"
                            ></ResponsiveImage>
                            <p>Step {{ stepsOrder[slotProps.index] }}: {{ steps[stepsOrder[slotProps.index]].text }}</p>
                        </v-flex>
                    </v-layout>
                </v-container>
            </template>
        </Carousel>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        steps: get('section12/steps'),
        stepsOrder: get('section12/stepsOrder'),
        allStepsVisited: get('section12/allStepsVisited')
    },
    methods: {
        change(index) {
            this.$store.set(`section12/steps@${index + 1}.visited`, true);
        },
        nextDisabled() {
            return !this.allStepsVisited;
        }
    }
};
</script>
